import { render } from "./TagUpsert.vue?vue&type=template&id=5c42e50c"
import script from "./TagUpsert.vue?vue&type=script&lang=js"
export * from "./TagUpsert.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__